require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-mq-0-yz-ei-tth-xns-tgv-eu-pe-7.json") })
        }
      }, "path---news-mq-0-yz-ei-tth-xns-tgv-eu-pe-7");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-mq-0-yz-ei-tth-xns-tgv-eu-pe-7!./.cache/json/news-mq-0-yz-ei-tth-xns-tgv-eu-pe-7.json
// module id = ./node_modules/gatsby-module-loader/index.js?name=path---news-mq-0-yz-ei-tth-xns-tgv-eu-pe-7!./.cache/json/news-mq-0-yz-ei-tth-xns-tgv-eu-pe-7.json
// module chunks = 231608221292675